import { GridCard } from '@/components/Card'
import { EmptyList } from '@/components/EmptyList'
import { SidePanel } from '@/components/SidePanel'
import { useGrids } from '@/queries/grids/useGrids'
import { resetGrid } from '@/redux/store/slices/grid/gridSlice'
import { useAppDispatch } from '@redux/hooks/useAppState'
import { nanoid } from '@reduxjs/toolkit'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const GridsList = () => {
	const { organization } = useStytchOrganization()
	const [searchParams] = useSearchParams()
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	const { data: grids = [], isLoading } = useGrids({
		workspaceId: organization?.organization_id,
		include: 'currentVersion',
	})
	const selectedGridId = searchParams.get('gridId')
	const showEmptyList = !isLoading && !grids?.length

	const onAdd = () => {
		dispatch(resetGrid())
		const tempGridId = nanoid(16)
		navigate(`add?gridId=${tempGridId}`)
	}

	useEffect(() => {
		if (grids?.length && !selectedGridId) {
			navigate(`?gridId=${grids[0].uuid}`, { replace: true })
		}
	}, [selectedGridId, grids, navigate])

	return (
		<SidePanel
			header={{
				title: 'Grids',
				onAdd,
			}}
		>
			<div className="flex flex-col w-full gap-3 items-center">
				{showEmptyList ? (
					<div className="w-full flex items-center">
						<EmptyList onAdd={onAdd} />
					</div>
				) : (
					grids?.map((grid) => (
						<div key={grid.id} className="w-full">
							<GridCard grid={grid} isSelected={grid.uuid === selectedGridId} />
						</div>
					))
				)}
			</div>
		</SidePanel>
	)
}
